









































import AppBarHelp from 'vuecomponents/app_bar_help.vue'
import AppBarAccount from 'vuecomponents/app_bar_account.vue'
import BaseTextTabs, { BaseTextTabsTab } from 'vuecomponents/base_text_tabs.vue'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { UpgradeSource } from 'vuexstore/modules/plans'

const plans = namespace('plans')

@Component({
  components: {
    AppBarHelp,
    AppBarAccount,
    BaseTextTabs,
  },
})
export default class AppBarNav extends Mixins() {
  @Prop(Object) user
  @Prop({ default: () => [] }) sessions
  @Prop({ default: null }) currentTenantId
  @Prop({ default: false }) inlineSessionTabs

  @plans.Action userTriggeredUpgrade!: Function

  UpgradeSource = UpgradeSource

  get isUserRegistered(): boolean {
    return !!this.user.registered_at || this.user.registered
  }

  get xSession(): boolean {
    return this.sessions.length > 0
  }

  get xSessionTabsInline(): boolean {
    return this.xSession && this.inlineSessionTabs
  }

  get xSessionTabsBar(): boolean {
    return this.xSession && !this.inlineSessionTabs
  }

  get sessionTabsData(): BaseTextTabsTab[] {
    return this.sessions.map((session) => ({
      key: session.tenant.id,
      text:
        session.tenant.id === 1 && this.__
          ? session.user.paying
            ? this.__('Padlet Pro')
            : this.__('Padlet Basic')
          : session.tenant.name,
      href: `https://${session.tenant.domain_name}`,
    }))
  }
}
